import React from 'react';
import { Minus, Square, X, Crown, Search, Bell, Settings } from 'lucide-react';
import './TitleBar.css';

function TitleBar({ onOpenSettings }) {
  const handleMinimize = () => {
    window.electronAPI?.minimizeWindow();
  };

  const handleMaximize = () => {
    window.electronAPI?.maximizeWindow();
  };

  const handleClose = () => {
    window.electronAPI?.closeWindow();
  };

  return (
    <div className="titlebar">
      <div className="titlebar-drag">
        <div className="titlebar-brand">
          <div className="brand-logo">
            <Crown size={20} />
          </div>
          <div className="brand-text">
            <span className="brand-name">FEK</span>
          </div>
        </div>
        
        <div className="titlebar-center">
          <div className="global-search">
            <Search size={14} />
            <span>Search or jump to...</span>
            <kbd>Ctrl K</kbd>
          </div>
        </div>
        
        <div className="titlebar-actions">
          <button className="action-btn" title="Notifications">
            <Bell size={18} />
            <span className="notification-dot"></span>
          </button>
          <button className="action-btn" title="Settings" onClick={onOpenSettings}>
            <Settings size={18} />
          </button>
        </div>
      </div>
      
      <div className="window-controls">
        <button className="control-btn" onClick={handleMinimize}>
          <Minus size={14} />
        </button>
        <button className="control-btn" onClick={handleMaximize}>
          <Square size={12} />
        </button>
        <button className="control-btn close" onClick={handleClose}>
          <X size={14} />
        </button>
      </div>
    </div>
  );
}

export default TitleBar;
